var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44629 0.864502C2.89943 1.6011 1.60086 2.89967 0.864258 4.44653L2.06868 5.01945C2.26435 4.60855 2.58292 4.25639 2.87467 3.89054C1.95992 5.03162 1.33301 6.41964 1.33301 7.99992C1.33301 11.6888 4.31079 14.6666 7.99967 14.6666C11.6886 14.6666 14.6663 11.6888 14.6663 7.99992C14.6663 6.41964 14.0394 5.03162 13.1247 3.89054C13.4164 4.25639 13.735 4.60855 13.9307 5.01945L15.1351 4.44653C14.3985 2.89967 13.0999 1.6011 11.5531 0.864502L10.9801 2.06893C11.391 2.26459 11.7432 2.58316 12.109 2.87492C10.968 1.96017 9.57996 1.33325 7.99967 1.33325C6.41939 1.33325 5.03138 1.96017 3.8903 2.87492C4.25614 2.58316 4.60831 2.26459 5.01921 2.06893L4.44629 0.864502ZM7.99967 2.66659C10.9775 2.66659 13.333 5.02214 13.333 7.99992C13.333 10.9777 10.9775 13.3333 7.99967 13.3333C5.0219 13.3333 2.66634 10.9777 2.66634 7.99992C2.66634 5.02214 5.0219 2.66659 7.99967 2.66659ZM7.33301 4.66658V8.27596L9.52832 10.4713L10.471 9.52856L8.66634 7.72388V4.66658H7.33301Z",
    fill: "#7A7D80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.4138872ef47dcdd57a8352628d2a2fca.svg";
export { ForwardRef as ReactComponent };